import { createContext } from 'react';

import { Context } from '../../../types';
import { SupplierAccount } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<SupplierAccount>>(getContextDefaultValues(api));
